import type { ApiError } from "@/lib/api";
import { api } from "@/lib/api";
import type { BadgeDefinition } from "@/types";

export interface BadgeDefinitionResponse {
  badgeId: string;
  name: string;
  description: string;
  iconEmoji: string;
  stepThreshold: number;
  tier: string;
}

export async function getCompetitionBadges(
  competitionId: string,
  userId: string,
): Promise<{ data: BadgeDefinition[] | null; error: ApiError | null }> {
  return api.get<BadgeDefinition[]>(`/competitions/${competitionId}/badges/${userId}`);
}

export async function getCompetitionBadgePool(
  competitionId: string,
): Promise<{ data: BadgeDefinition[] | null; error: ApiError | null }> {
  return api.get<BadgeDefinition[]>(`/competitions/${competitionId}/badge-pool`);
}

export async function getAllBadgeDefinitions(): Promise<{
  data: BadgeDefinitionResponse[] | null;
  error: ApiError | null;
}> {
  return api.get<BadgeDefinitionResponse[]>(`/badge-definitions`);
}
